import { RefObject, useCallback, useEffect, useRef, useState } from "react";
import { debounce } from "../helpers";

export interface Dimensions {
    width: number;
    height: number;
}

interface IUseRefDimensionsProps {
    containerRef: RefObject<HTMLElement>;
}

interface IUseRefDimensions {
    dimensions: Dimensions;
}

const useRefDimensionsObserver = ({ containerRef }: IUseRefDimensionsProps): IUseRefDimensions => {
    const [dimensions, setDimensions] = useState<Dimensions>({ width: 0, height: 0 });

    const handleDimensionsChanged = useCallback(debounce(setDimensions, 100), []);

    const observer = useRef(
        new ResizeObserver(entries => {
            const { width, height } = entries[0].contentRect;
            handleDimensionsChanged({ width, height });
        })
    );

    useEffect(() => {
        containerRef.current && observer.current.observe(containerRef.current);

        return () => (containerRef.current ? observer.current.unobserve(containerRef.current) : undefined);
    }, [containerRef]);

    return {
        dimensions
    };
};

export default useRefDimensionsObserver;
